import {useCallback, useEffect, useState} from "react";

type NotificationOptions = {
  body?: string;
  icon?: string;
  badge?: string;
  vibrate?: number[];
  tag?: string;
  renotify?: boolean;
  silent?: boolean;
  requireInteraction?: boolean;
  actions?: NotificationAction[];
};

export function useBrowserNotification() {
  const [permission, setPermission] = useState<NotificationPermission>(
      Notification.permission
  );

  const requestPermission = useCallback(async () => {
    if (!("Notification" in window)) {
      return;
    }
    const result = await Notification.requestPermission();
    setPermission(result);
  }, []);

  const showBrowserNotification = useCallback(
      (title: string, options?: NotificationOptions) => {
        if (!("Notification" in window)) {
          return;
        }
        if (permission === "granted") {
          new Notification(title, options);
        } else if (permission === "default") {
          requestPermission().then(() => {
            if (Notification.permission === "granted") {
              new Notification(title, options);
            }
          });
        } else {
        }
      },
      [permission, requestPermission]
  );

  useEffect(() => {
    if (permission === "default") {
      requestPermission();
    }
  }, [permission, requestPermission]);

  return {permission, requestPermission, showBrowserNotification};
}
